import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { DismissedBannerKey } from '@/common/constants';
import { API_URL } from '@/dtos';

const useDismissBannerQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation((bannerKey: DismissedBannerKey) =>
    api.post(API_URL.BANNERS_DISMISS_BY_BANNER_KEY(bannerKey)), {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.BANNERS_DISMISSED],
        });
      },
    }
  );

  return {
    dismissBanner: mutateAsync,
    isDismissBannerLoading: isLoading,
  };
};

export default useDismissBannerQuery;
